<svg
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 16 16">
    <path d="M13 15l3-8h-13l-3 8zM2 6l-2 9v-13h4.5l2 2h6.5v2z"></path>
</svg>
    


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-folder-open.html